import { HttpErrorResponse } from '@angular/common/http';

export class ImATeapotError extends Error {
    httpStatus = 418;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, ImATeapotError.prototype);
    }
}
